import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full mb-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "insights", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2"
}
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col w-full text-center select-none mt-9"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, " assignment ", -1)
const _hoisted_8 = { class: "opacity-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EventEditorPreview = _resolveComponent("EventEditorPreview")!
  const _component_EventEditorPreviewSkeleton = _resolveComponent("EventEditorPreviewSkeleton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "ml-auto mr-4",
        to: { name: 'CourseInsights', hash: '#exams' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Btn, {
            class: "icon-btn-primary",
            tooltip: _ctx.$t('course_events.exams_stats'),
            variant: 'icon',
            outline: true
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["tooltip"])
        ]),
        _: 1
      }),
      (_ctx.firstLoading || _ctx.hasPrivileges([_ctx.CoursePrivilege.MANAGE_EVENTS]))
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAddExam())),
            loading: _ctx.localLoading,
            class: "",
            disabled: _ctx.firstLoading
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("course_events.new_exam")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.exams, (exam, index) => {
            return (_openBlock(), _createBlock(_component_EventEditorPreview, {
              key: exam + '-' + index,
              event: exam,
              onClose: ($event: any) => (_ctx.onCloseExam(exam)),
              onReopen: ($event: any) => (_ctx.onReopenExam(exam))
            }, null, 8, ["event", "onClose", "onReopen"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_EventEditorPreviewSkeleton),
          _createVNode(_component_EventEditorPreviewSkeleton),
          _createVNode(_component_EventEditorPreviewSkeleton),
          _createVNode(_component_EventEditorPreviewSkeleton),
          _createVNode(_component_EventEditorPreviewSkeleton),
          _createVNode(_component_EventEditorPreviewSkeleton)
        ])),
    (!_ctx.firstLoading && _ctx.mainStore.exams.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("course_events.no_exams")), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showBlockingDialog,
      onNo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resolveBlockingDialog(false))),
      onYes: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resolveBlockingDialog(true))),
      yesText: _ctx.blockingDialogData?.yesText,
      noText: _ctx.blockingDialogData?.noText
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.blockingDialogData?.title), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.blockingDialogData?.text), 1)
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "noText"])
  ]))
}